<script>
    export let icon;
    export let date;
    export let title;
</script>


<div class="container">
    <div id="{date}" class="title">

        {#if icon == 'alert'}
        <svg width="24" height="21" viewBox="0 0 24 21" class="icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.29 2.85999L1.82001 17C1.64537 17.3024 1.55297 17.6453 1.55199 17.9945C1.55102 18.3437 1.6415 18.6871 1.81443 18.9905C1.98737 19.2939 2.23673 19.5467 2.53771 19.7238C2.8387 19.9009 3.1808 19.9962 3.53001 20H20.47C20.8192 19.9962 21.1613 19.9009 21.4623 19.7238C21.7633 19.5467 22.0126 19.2939 22.1856 18.9905C22.3585 18.6871 22.449 18.3437 22.448 17.9945C22.447 17.6453 22.3546 17.3024 22.18 17L13.71 2.85999C13.5317 2.5661 13.2807 2.32311 12.9812 2.15447C12.6817 1.98584 12.3437 1.89725 12 1.89725C11.6563 1.89725 11.3183 1.98584 11.0188 2.15447C10.7193 2.32311 10.4683 2.5661 10.29 2.85999V2.85999Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 16H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {/if}

        {#if icon == 'star'}
        <svg width="22" height="22" viewBox="0 0 22 22" class="icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {/if}

        {#if icon == 'award'}
        <svg width="17" height="24" viewBox="0 0 17 25" class="icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.79388 15.8958C12.6599 15.8958 15.7939 12.7617 15.7939 8.89575C15.7939 5.02976 12.6599 1.89575 8.79388 1.89575C4.92789 1.89575 1.79388 5.02976 1.79388 8.89575C1.79388 12.7617 4.92789 15.8958 8.79388 15.8958Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.00388 14.7858L3.79388 23.8958L8.79388 20.8958L13.7939 23.8958L12.5839 14.7758" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {/if}

        {#if icon == 'gift'}
        <svg width="22" height="22" viewBox="0 0 22 22" class="icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 11V21H3V11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 6H1V11H21V6Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 21V6" troke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 6H6.5C5.83696 6 5.20107 5.73661 4.73223 5.26777C4.26339 4.79893 4 4.16304 4 3.5C4 2.83696 4.26339 2.20107 4.73223 1.73223C5.20107 1.26339 5.83696 1 6.5 1C10 1 11 6 11 6Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 6H15.5C16.163 6 16.7989 5.73661 17.2678 5.26777C17.7366 4.79893 18 4.16304 18 3.5C18 2.83696 17.7366 2.20107 17.2678 1.73223C16.7989 1.26339 16.163 1 15.5 1C12 1 11 6 11 6Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {/if}

        {#if icon == 'party'}
        <svg width="22" height="22" viewBox="0 0 22 22" class="icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5713 14.5L9.46583 18.4141M18.9996 3.60975C17.4044 3.59505 16.6658 4.33233 16.4236 5.07743C16.2103 5.73354 16.4052 7.07735 15.896 8.0727C15.4091 9.02443 14.1204 9.5617 12.6571 9.60697M20 7.6104L20.01 7.61049M19 15.96L19.01 15.9601M7.00001 3.94926L7.01001 3.94936M19 11.1094C17.5 11.1094 16.5 11.6094 15.5949 12.5447M10.2377 7.18796C11 6.10991 11.5 5.10991 11.0082 3.52734M3.53577 20.4645L7.0713 9.85791L14.1424 16.929L3.53577 20.4645Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {/if}

        {date}
        <span class="separator">-</span>
        {title}
    </div>
    <div class="content">
        <slot name="content"></slot>
    </div>
</div>



<style>

    .container {
        border: 1px solid var(--clr-foreground-300);
        border-radius: 8px;
        text-align: justify;
        padding-top: 1.7em;
        padding-bottom: 1em;
        padding-inline: 2.5em;
        word-wrap: break-word;
        font-size: 1em;
    }

    .title {
        font-weight: 600;
        margin-bottom: 0.7em;
        display: flex;
        gap: 0.5em;
        align-items: flex-start;
    }

    .separator {
        /* padding-inline: 0.25em; */
        font-weight: 400;
    }

    .icon {
        fill: none;
        stroke: currentColor;
        margin-right: 0.5em;
        margin-top: -3px;
    }


@media screen and (max-width: 500px)
{
	.container {
        padding-inline: 1em;
        font-size: 0.9em;
        text-align: left;
    }
}

</style>